<div class="navbar-container" [class.example-is-mobile]="mobileQuery.matches">
  <!-- Top navbar -->
  <mat-toolbar class="navbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon color="primary">menu</mat-icon>
    </button>
    <a class="navbar-brand" [routerLink]="['/']" matTooltip="Home">
      <img class="logo-header" alt="logo" src="/assets/healic-logo.webp" />
    </a>
    <span class="navbar-spacer"></span>
    <div class="user_details_text">
      <p
        id="tooltipUser"
        [title]="getTooltip()"
        style="font-size: 15px; font-weight: 500"
      >
        {{ getLoggedInUserRole() }}
      </p>
      <p
        #clinicLocationName
        [matTooltip]="getTooltipIfOverflow(clinicLocationName)"
        id="clinic-location-name"
        (click)="openClinicLocationSelect()"
        *ngIf="currentClinic"
      >
        <mat-icon svgIcon="location"></mat-icon>
        {{ currentClinic?.name }}
      </p>
      <mat-select
        class="custom-select select_clinic_list"
        #clinicLocationSelect
        (selectionChange)="onClinicLocationSelect($event)"
        [formControl]="clinicLocationControl"
      >
        <mat-select-filter
          *ngIf="clinicLocationSelect.focused"
          [array]="clinicLocations"
          [displayMember]="'name'"
          (filteredReturn)="filteredClinicLocations = $event"
        ></mat-select-filter>

        <mat-option
          *ngFor="let clinic of filteredClinicLocations"
          [value]="clinic"
          [ngClass]="{ highlighted: isSelected(clinic) }"
        >
          {{ clinic.name }}
        </mat-option>
      </mat-select>
    </div>

    <button
      disabled="true"
      mat-icon-button
      [matMenuTriggerFor]="notificationMenu"
    >
      <mat-icon style="color: #4e5072; font-size: 25px"
        >account_circle</mat-icon
      >
    </button>

    <mat-menu
      #notificationMenu="matMenu"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <a mat-menu-item>
        <span>You have new tasks</span>
      </a>
      <a mat-menu-item>
        <span>You have a new message</span>
      </a>
    </mat-menu>
  </mat-toolbar>
  <mat-sidenav-container autosize class="navbar-sidenav-container">
    <!-- Side nav -->
    <mat-sidenav
      #snav
      [opened]="!mobileQuery.matches"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56"
      class="sidenav"
    >
      <mat-nav-list>
        <a
          *ngIf="isAdmin || isReceptionist || isClinicManager || isOpsManager"
          mat-list-item
          [routerLink]="['/doctors']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> business_center </mat-icon>
          <p mat-line>{{ "Doctors.Self" | translate }}</p>
        </a>
        <a
          *ngIf="isAdmin || isReceptionist || isClinicManager || isOpsManager"
          mat-list-item
          [routerLink]="['/patients']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> groups </mat-icon>
          <p mat-line>{{ "Patients.Self" | translate }}</p>
        </a>
        <a
          *ngIf="
            isAdmin ||
            isClinicManager ||
            isOpsManager ||
            isPharmacist ||
            isPharmacyManager ||
            isStockTransfer ||
            isPharmacyOperator ||
            isReceptionist
          "
          mat-list-item
          [routerLink]="['/all-appointment']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon>calendar_month</mat-icon
          ><span>
            <p mat-line style="margin-left: 15px">
              {{ "Appointment.Self" | translate }}
            </p>
          </span>
        </a>

        <a
          *ngIf="isAdmin || isOpsManager"
          mat-list-item
          [routerLink]="['/activity-log']"
          routerLinkActive="active"
          #activity="routerLinkActive"
        >
          <mat-icon
            class="whatsapp-icon"
            [svgIcon]="activity.isActive ? 'activity-light' : 'activity-dark'"
            mat-list-icon
          ></mat-icon
          ><span>
            <p mat-line style="margin-left: 15px">
              {{ "Activity Log" | translate }}
            </p>
          </span>
        </a>

        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/all-prescription']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> list_alt </mat-icon>
          <p mat-line>{{ "AllPrescription.self" | translate }}</p>
        </a>

        <mat-expansion-panel
          #matExpansionPanel
          [expanded]="_router.url.startsWith('/process')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon
                  id="pharmacy-icon"
                  color="primary"
                  mat-list-icon
                  svgIcon="ps-b"
                  class="menu-icon"
                ></mat-icon>
                <p mat-line>{{ "ProcessScheduler.Self" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container>
            <a
              mat-list-item
              *ngIf="isAdmin || isOpsManager"
              [routerLink]="['/process/scheduler']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "ProcessScheduler.Process" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              *ngIf="isAdmin || isOpsManager || isTaskReviewer"
              [routerLink]="['/process/list']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "ProcessScheduler.Task" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/process/assign-me']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "ProcessScheduler.AssignToMe" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              *ngIf="isAdmin || isOpsManager || isAuditor"
              [routerLink]="['/process/auditor']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Audit" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              *ngIf="isAdmin || isOpsManager"
              [routerLink]="['/process/group']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Group" | translate }}
              </p>
            </a>
          </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel
          *ngIf="isAdmin || isOpsManager"
          #matExpansionPanel
          [expanded]="_router.url.startsWith('/ipd-payout')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon
                  id="pharmacy-icon"
                  color="primary"
                  mat-list-icon
                  svgIcon="payoutB"
                  class="menu-icon"
                ></mat-icon>
                <p mat-line>{{ "IPDPayout.Self" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container>
            <a
              mat-list-item
              [routerLink]="['/ipd-payout/detail-payout']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Surgeon</p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/ipd-payout/other-dr-payout']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Other Dr Payouts</p>
            </a>
          </ng-container>
        </mat-expansion-panel>

        <!-- New Approval Expansion Panel -->
        <mat-expansion-panel
          *ngIf="isAdmin || isOpsManager"
          #matExpansionPanel
          [expanded]="_router.url.includes('/approval-')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon color="primary" mat-list-icon class="menu-icon"
                  >settings</mat-icon
                >
                <p mat-line>{{ "IPDPayoutApproval.Self" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container>
            <a
              mat-list-item
              [routerLink]="['/ipd-payout/approval-surgeon']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Surgeon</p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/ipd-payout/approval-other-dr']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Other Doctor</p>
            </a>
          </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel
          *ngIf="pharmacyMenuVisible"
          #matExpansionPanel
          [expanded]="isExpanded('pharmacyModule')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon
                  id="pharmacy-icon"
                  color="primary"
                  mat-list-icon
                  svgIcon="pharmacy"
                  class="menu-icon"
                ></mat-icon>
                <p mat-line>{{ "Pharmacy.Self" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/inventory']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "PharmaMedicine.Self" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/purchases']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.Purchases.Self" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/purchases-returns']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.Purchases.Return" | translate }}
              </p>
            </a>
            <a
              *ngIf="
                isAdmin || isPharmacyManager || isStockTransfer || isOpsManager
              "
              mat-list-item
              [routerLink]="['/pharmacy/approve-purchase']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.Purchases.Approve" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/indent-request']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Indent Request</p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/store-return-approval']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Store Return Approval</p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/stock-transfer']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Stock Transfer</p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/bills']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Sales" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/store-bills']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Store Bill</p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/refill']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Refills" | translate }}
              </p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/sales-return']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.Bills.return" | translate }}
              </p>
            </a>

            <a
              *ngIf="
                isAdmin ||
                isPharmacyManager ||
                isStockTransfer ||
                isPharmacist ||
                isOpsManager
              "
              mat-list-item
              [routerLink]="['/pharmacy/stock-adjustment']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.Bills.adjustInventoy" | translate }}
              </p>
            </a>

            <a
              mat-list-item
              [routerLink]="['/pharmacy/expired-medicine']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.ExpiredMedicine.Self" | translate }}
              </p>
            </a>
            <a
              mat-list-item
              [routerLink]="['/pharmacy/expiring-medicine']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.ExpiringMedicine.Self" | translate }}
              </p>
            </a>
          </ng-container>
        </mat-expansion-panel>

        <mat-expansion-panel
          *ngIf="
            isAdmin ||
            isOpsManager ||
            isClinicManager ||
            isStoreManager ||
            isStoreApproval
          "
          #matExpansionPanel
          [expanded]="isExpanded('storeModule')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon
                  color="primary"
                  mat-list-icon
                  svgIcon="storeB"
                  class="menu-icon"
                  style="width: 28px !important; margin-left: 0px !important"
                ></mat-icon>
                <p mat-line>{{ "Store" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container>
            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/inventory']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Inventory" | translate }}
              </p>
            </a>
            <a
              *ngIf="
                isAdmin ||
                isOpsManager ||
                isClinicManager ||
                isStoreManager ||
                isStoreApproval
              "
              mat-list-item
              [routerLink]="['/store/indent']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ isOnlyStoreApprovalRole ? "Store Approval" : "Indent" }}
              </p>
            </a>

            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/loose-inventory']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Loose Inventory</p>
            </a>
            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/return']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Store Return</p>
            </a>

            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/usages']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>Usage</p>
            </a>
            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/expired-medicine']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.ExpiredMedicine.Self" | translate }}
              </p>
            </a>
            <a
              *ngIf="!isOnlyStoreApprovalRole"
              mat-list-item
              [routerLink]="['/store/expiring-medicine']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Pharmacy.ExpiringMedicine.Self" | translate }}
              </p>
            </a>
          </ng-container>
        </mat-expansion-panel>

        <a
          *ngIf="
            isPharmacyOperator &&
            !isPharmacyManager &&
            !isStockTransfer &&
            approveMenuVisible &&
            !isAdmin
          "
          mat-list-item
          [routerLink]="['/pharmacy/approve-purchase']"
          routerLinkActive="active"
        >
          <mat-icon
            color="primary"
            class="menu-icon"
            svgIcon="approve"
            mat-list-icon
          >
          </mat-icon
          ><span>
            <p mat-line style="margin-left: 15px">
              {{ "Pharmacy.ApprovePurchases.Self" | translate }}
            </p>
          </span>
        </a>

        <a
          *ngIf="
            isPharmacyOperator &&
            !isPharmacyManager &&
            !isStockTransfer &&
            !isPharmacist &&
            approveMenuVisible &&
            !isAdmin
          "
          mat-list-item
          [routerLink]="['/pharmacy/stock-adjustment']"
          routerLinkActive="active"
        >
          <p class="submenu" mat-line>
            {{ "Pharmacy.Bills.adjustInventoy" | translate }}
          </p>
        </a>

        <a
          *ngIf="isAdmin || isReceptionist || isClinicManager || isOpsManager"
          mat-list-item
          [routerLink]="['/services/clinic-services']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="menu-icon"
            mat-list-icon
            [svgIcon]="rla.isActive ? 'ServiceW' : 'Service'"
          ></mat-icon>

          <p mat-line>
            {{ "Service & Packages" | translate }}
          </p>
        </a>

        <a
          *ngIf="isAdmin || isReceptionist || isClinicManager || isOpsManager"
          mat-list-item
          [routerLink]="['/services/bills']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            id="pharmacy-icon"
            color="primary"
            mat-list-icon
            [svgIcon]="rla.isActive ? 'service-bills-W' : 'service-bills'"
            class="menu-icon"
          ></mat-icon>

          <p mat-line>
            {{ "OPD" | translate }}
          </p>
        </a>

        <a
          *ngIf="isAdmin || isClinicManager || isOpsManager || isReceptionist"
          mat-list-item
          [routerLink]="['/ipd/list']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> business_center </mat-icon>
          <p mat-line>{{ "IPD" | translate }}</p>
        </a>

        <a
          *ngIf="isAdmin || isClinicManager || isOpsManager || isReceptionist"
          mat-list-item
          [routerLink]="['/packages']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="menu-icon"
            color="primary"
            mat-list-icon
            [svgIcon]="'file'"
            [ngClass]="rla.isActive ? 'active-icon' : ''"
          >
          </mat-icon>
          <p mat-line>{{ "Subscription" | translate }}</p>
        </a>

        <a
          *ngIf="isAdmin || isClinicManager || isOpsManager || isReceptionist"
          mat-list-item
          [routerLink]="['/refund']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="whatsapp-icon"
            mat-list-icon
            [svgIcon]="rla.isActive ? 'refnd_W' : 'refnd_B'"
          >
          </mat-icon>
          <p mat-line>{{ "Refunds" | translate }}</p>
        </a>

        <a
          mat-list-item
          *ngIf="isAdmin || isWhatsAppOperator"
          [routerLink]="['/messages']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="whatsapp-icon"
            [svgIcon]="rla.isActive ? 'whats-app-white' : 'whats-app'"
            mat-list-icon
          >
          </mat-icon>
          <p mat-line>{{ "WhatsApp Msgs" | translate }}</p>
        </a>
        <mat-expansion-panel
          *ngIf="isAdmin || isPharmacyManager"
          #matExpansionPanel
          [expanded]="_router.url.startsWith('/masters')"
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="expand-menu-header">
            <mat-panel-title>
              <a mat-list-item>
                <mat-icon color="primary" mat-list-icon> settings </mat-icon>
                <p mat-line>{{ "Masters.Self" | translate }}</p>
              </a>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-container>
            <mat-expansion-panel
              *ngIf="isAdmin"
              #matExpansionPanel
              [expanded]="isExpanded('medicineProfile')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item id="pharmacy-master-title">
                    <p mat-line>{{ "Medical Profile" | translate }}</p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                mat-list-item
                [routerLink]="['/masters/blood-group']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>{{ "BloodGroup" | translate }}</p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/food-allergies']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.FoodAllergies.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/other-allergies']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.OtherAllergies.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/medicines']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.Medicines.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/medicine-type']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.MedicineType.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/diseases']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.Diseases.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/procedures']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.Procedures.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/family-relations']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.FamilyRelations.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/family-history-diseases']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.FamilyHistoryDiseases.Self" | translate }}
                </p>
              </a>
              <a
                mat-list-item
                [routerLink]="['/masters/symptoms']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.Symptoms.Self" | translate }}
                </p>
              </a>
            </mat-expansion-panel>

            <mat-expansion-panel
              *ngIf="isAdmin"
              #matExpansionPanel
              [expanded]="isExpanded('doctorProfile')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item id="pharmacy-master-title">
                    <p mat-line>{{ "Doctor Profile" | translate }}</p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                mat-list-item
                [routerLink]="['/masters/specialization']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Specialization" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/professional-qualification']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "ProfessionalQualification" | translate }}
                </p>
              </a>
              <a
                mat-list-item
                [routerLink]="['/masters/council']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>{{ "Council" | translate }}</p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/category']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.Category.Self" | translate }}
                </p>
              </a>
            </mat-expansion-panel>

            <mat-expansion-panel
              *ngIf="isAdmin"
              #matExpansionPanel
              [expanded]="isExpanded('appointment')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item id="pharmacy-master-title">
                    <p mat-line>{{ "Appointment" }}</p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                mat-list-item
                [routerLink]="['/masters/test-reasons']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.TestReasons.Self" | translate }}
                </p>
              </a>
            </mat-expansion-panel>

            <!-- <a
              mat-list-item
              [routerLink]="['/masters/services']"
              routerLinkActive="active"
            >
              <p class="submenu" mat-line>
                {{ "Services" }}
              </p>
            </a> -->

            <mat-expansion-panel
              *ngIf="isAdmin || isPharmacyManager"
              #matExpansionPanel
              [expanded]="isExpanded('pharmacy')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item>
                    <p mat-line id="pharmacy-master-title">
                      {{ "Pharmacy.Self" | translate }}
                    </p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-container>
                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/medicine-type']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.MedicineType" | translate }}
                  </p>
                </a>

                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/medicine-brand']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.MedicineBrand" | translate }}
                  </p>
                </a>
                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/medicine-category']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.MedicineCategory" | translate }}
                  </p>
                </a>
                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/packing-type']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.PackingType" | translate }}
                  </p>
                </a>
                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/medicines']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.medicines" | translate }}
                  </p>
                </a>

                <a
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/distributors']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Distributor" | translate }}
                  </p>
                </a>

                <a
                  *ngIf="isAdmin || isMaximumDiscountOverride"
                  mat-list-item
                  [routerLink]="['/masters/pharmacy/margin-slab']"
                  routerLinkActive="active"
                >
                  <p class="submenu pharmacy-master-item" mat-line>
                    {{ "Pharmacy.Masters.MarginSlab" | translate }}
                  </p>
                </a>
              </ng-container>
            </mat-expansion-panel>

            <mat-expansion-panel
              *ngIf="isAdmin"
              #matExpansionPanel
              [expanded]="isExpanded('service')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item id="pharmacy-master-title">
                    <p mat-line>{{ "Services" }}</p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                mat-list-item
                [routerLink]="['/masters/service-category']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Services Category" | translate }}
                </p>
              </a>
              <a
                mat-list-item
                [routerLink]="['/masters/service-subCategory']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Services Sub Category" | translate }}
                </p>
              </a>
              <a
                mat-list-item
                [routerLink]="['/masters/service']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Service & Packages" | translate }}
                </p>
              </a>
            </mat-expansion-panel>

            <mat-expansion-panel
              *ngIf="isAdmin"
              #matExpansionPanel
              [expanded]="isExpanded('others')"
              class="mat-elevation-z0"
            >
              <mat-expansion-panel-header class="expand-menu-header">
                <mat-panel-title>
                  <a mat-list-item id="pharmacy-master-title">
                    <p mat-line>{{ "Others" }}</p>
                  </a>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <a
                mat-list-item
                [routerLink]="['/masters/cancellation-reasons']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Cancellation Reasons" }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/source-type']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.SourceType.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/primary-source']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.PrimarySource.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/secondary-source']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.SecondarySource.Self" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/state']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Masters.State.Self" | translate }}
                </p>
              </a>
              <a
                mat-list-item
                [routerLink]="['/masters/city']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>{{ "City" | translate }}</p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/bill-category']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Bill Category" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/tpa']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "TPA" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/process-category']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Process Category" | translate }}
                </p>
              </a>

              <a
                mat-list-item
                [routerLink]="['/masters/treatment']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>{{ "Treatment" | translate }}</p>
              </a>

              <a
                *ngIf="isAdmin || isOpsManager"
                mat-list-item
                [routerLink]="['/masters/payout-setting']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "Payout Setting" | translate }}
                </p>
              </a>
              <a
                *ngIf="isAdmin || isOpsManager"
                mat-list-item
                [routerLink]="['/masters/ipd-bill-setting']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>
                  {{ "IPD Bill Setting" | translate }}
                </p>
              </a>
              <a
                *ngIf="isAdmin || isOpsManager"
                mat-list-item
                [routerLink]="['/masters/add-expense-category']"
                routerLinkActive="active"
              >
                <p class="submenu" mat-line>Add Expense Category</p>
              </a>
            </mat-expansion-panel>
          </ng-container>
        </mat-expansion-panel>
        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/managed-coupon']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> redeem </mat-icon>
          <p mat-line>{{ "Manage Coupon" | translate }}</p>
        </a>
        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/managed-clinic']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> business </mat-icon>
          <p mat-line>{{ "Manage Hospital" | translate }}</p>
        </a>
        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/banner-app']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="menu-icon"
            [svgIcon]="rla.isActive ? 'banner-app-light' : 'banner-app'"
            mat-list-icon
          >
          </mat-icon>
          <p mat-line>{{ "Banner for App" | translate }}</p>
        </a>
        <a
          mat-list-item
          *ngIf="
            isAdmin
              ? false
              : isOpsManager
              ? true
              : isClinicManager
              ? true
              : false
          "
          [routerLink]="['/receptionist']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> person </mat-icon>
          <p mat-line>{{ "Receptionist.Self" | translate }}</p>
        </a>
        <a
          mat-list-item
          *ngIf="isAdmin"
          [routerLink]="['/staff']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> person </mat-icon>
          <p mat-line>{{ "Staff.Self" | translate }}</p>
        </a>
        <a
          *ngIf="isAdmin || isClinicManager || isOpsManager"
          mat-list-item
          [routerLink]="['/all-wallet-transaction']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="menu-icon"
            [svgIcon]="rla.isActive ? 'wallet-light' : 'wallet'"
            mat-list-icon
          >
          </mat-icon>
          <p mat-line>{{ "AllWalletTransaction.self" | translate }}</p>
        </a>

        <a
          mat-list-item
          *ngIf="
            isAdmin ||
            isClinicManager ||
            isOpsManager ||
            isPharmacyManager ||
            isPharmacist ||
            isReceptionist
          "
          [routerLink]="['/cashflow/reco-list']"
          routerLinkActive="active"
          #rla="routerLinkActive"
        >
          <mat-icon
            class="menu-icon"
            [svgIcon]="rla.isActive ? 'cashRecoW' : 'cashRecoB'"
            mat-list-icon
          >
          </mat-icon>
          <p mat-line>{{ "Cash Reco" | translate }}</p>
        </a>

        <a
          *ngIf="
            isAdmin ||
            isClinicManager ||
            isOpsManager ||
            isPharmacyManager ||
            isPharmacist ||
            isReceptionist
          "
          mat-list-item
          [routerLink]="['/cashflow/add-expense']"
          routerLinkActive="active"
          #rla="routerLinkActive"
          dir="ltr"
        >
          <mat-icon
            mat-list-icon
            [style.color]="rla.isActive ? 'white' : '#4e5072'"
            >money</mat-icon
          >
          <p mat-line>{{ "Add Cash Expense" | translate }}</p>
        </a>

        <!-- editing -->
        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/lab-reports/records']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> note_add </mat-icon>
          <p mat-line>{{ "LabReports" | translate }}</p>
        </a>
        <a
          *ngIf="isAdmin"
          mat-list-item
          [routerLink]="['/lab-master']"
          routerLinkActive="active"
        >
          <mat-icon color="primary" mat-list-icon> biotech </mat-icon>
          <p mat-line>{{ "LabMaster" | translate }}</p>
        </a>
        <mat-divider></mat-divider>
        <a
          *ngIf="!isAdmin"
          mat-list-item
          [routerLink]="['/account/reset-password']"
          routerLinkActive="active"
        >
          <mat-icon mat-list-icon>lock_reset</mat-icon>
          <p mat-line>Reset Password</p>
        </a>
        <a mat-list-item [routerLink]="['/auth/login']">
          <mat-icon mat-list-icon>exit_to_app</mat-icon>
          <p mat-line>Log out</p>
        </a>
      </mat-nav-list>
    </mat-sidenav>
    <!-- Main content -->
    <mat-sidenav-content class="sidenav-content">
      <div class="progress-bar-container">
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
          *ngIf="spinnerService.visibility | async"
        >
        </mat-progress-bar>
        <!-- <mat-spinner class="spinner" [diameter]="50" *ngIf="spinnerService.visibility | async"></mat-spinner> -->
      </div>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
